import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-meteoservice-select',
    templateUrl: './meteoservice-select.component.html',
    styleUrls: ['./meteoservice-select.component.scss'],
    standalone: false
})
export class MeteoServiceSelectComponent implements OnInit, OnChanges {
  @Input() allowsMultiSelection = false;
  @Input() options: string[];
  @Input() optionsInactive: string[] = [];
  @Input() selected: string;
  @Input() selectedMulti: string[];
  @Output() selectedChanged = new EventEmitter();

  public selectedMeteos: string[];
  public meteoServicesLabels = {
    windlog: {
      label: 'POWER_FORECAST.FORECAST_SELECT.WIND_LOG',
    },
    meteoblue: {
      label: 'POWER_FORECAST.FORECAST_SELECT.METEOBLUE',
    },
    ecmwf: {
      label: 'POWER_FORECAST.FORECAST_SELECT.ECMWF',
    },
    nems: {
      label: 'POWER_FORECAST.FORECAST_SELECT.NEMS',
    },
    openweather: {
      label: 'POWER_FORECAST.FORECAST_SELECT.OPEN_WEATHER',
    },
    bkw_trading: {
      label: 'POWER_FORECAST.FORECAST_SELECT.BKW_TRADING',
    },
    meteologica: {
      label: 'POWER_FORECAST.FORECAST_SELECT.METEOLOGICA',
    },
    dnv_forecaster: {
      label: 'POWER_FORECAST.FORECAST_SELECT.DNV_FORECASTER',
    }
  };

  rotattion = {
    transform: 'rotate(0deg)'
  };

  public theme$ = new BehaviorSubject('');

  public isAllSelected = false;

  constructor(private themeService: ThemeService) {}

  public ngOnInit() {
    this.theme$ = this.themeService.getTheme();

    if (this.selected) {
      this.selectedMeteos = Array.isArray(this.selected) ? this.selected : [this.selected];
    } else if (this.selectedMulti) {
      this.selectedMeteos = this.selectedMulti;
    }
    else {
      this.selectedMeteos = ['windlog'];
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected && changes.selected.currentValue) {
      this.selectedMeteos = changes.selected.currentValue;
      this.isAllSelected = !this.options.find(o => !this.selectedMeteos.includes(o));
    }
  }

  optionSelected(option): void {
    if (this.optionsInactive.indexOf(option) > -1) {
      return;
    }

    if (option) {
      this.selectedMeteos = [option];
    }
    this.selectedChanged.emit(this.selectedMeteos[0]);
  }

  optionSelectedMulti(service) {
    if (this.optionsInactive.indexOf(service) > -1) {
      return;
    }

    if (!this.allowsMultiSelection) {
      this.optionSelected(service);
      return;
    }

    if (service === 'all') {
      if (this.isAllSelected) { // you can't unselect all
        return;
      } else {
        this.selectedMeteos = [];
        let notAll = false;
        this.options.forEach(op => {
          if (this.optionsInactive.indexOf(op) === -1) {
            this.selectedMeteos.push(op);
          } else {
            notAll = true;
          }

        });
        this.isAllSelected = !notAll;
      }
    } else {
      if (this.isAllSelected) {
        this.selectedMeteos = [];
      }
      this.isAllSelected = false;

      const index = this.selectedMeteos.indexOf(service);
      if (index > -1) {
        if (this.selectedMeteos.length > 1) { // you can not remove the last one!
          this.selectedMeteos.splice(index, 1);
        }
      } else {
          this.selectedMeteos.push(service);
      }
    }
    this.selectedChanged.emit(this.selectedMeteos);
  }

}
